var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transactions-list',{ref:"list",attrs:{"data-func":_vm.getTransactions,"show-user":true,"min-amount-filter":3000000}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/warn-transactions.vue?vue&type=template&id=5b1b9dd0&scoped=true
// module id = 7vey
// module chunks = 0